// extracted by mini-css-extract-plugin
export default {"container":"UM-z","darkBackground":"VM-z","whiteBackground":"WM-z","headerButton":"XM-z","calloutHeading":"YM-z","calloutSubHeading":"ZM-z"};